import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { GlobalStyle } from './styles';
var GlobalStyleComponent = /*#__PURE__*/function (_PureComponent) {
  _inherits(GlobalStyleComponent, _PureComponent);
  var _super = _createSuper(GlobalStyleComponent);
  function GlobalStyleComponent() {
    _classCallCheck(this, GlobalStyleComponent);
    return _super.apply(this, arguments);
  }
  _createClass(GlobalStyleComponent, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(GlobalStyle, {
        direction: this.props.direction
      });
    }
  }]);
  return GlobalStyleComponent;
}(PureComponent);
export { GlobalStyleComponent as default };